// Centralized external URLs and token configuration (typed placeholders, no fabricated data).
export const TOKEN_CONFIG = {
  network: "BNB Smart Chain",
  networkStatus: "Planned", // subject to final deployment confirmation
  contractAddress: null, // => renders "Coming Soon"
  contractStatus: "COMING_SOON",
  treasuryAddress: null,
  treasuryStatus: "Not Yet Available",
  buyUrl: "https://flap.sh",
  chartUrl: "https://dexscreener.com/",
  chartIsVerifiedPair: false, // general Dexscreener link, NOT a verified LUMORA chart
  auditStatus: "Not Yet Available",
  // Tokenomics are NOT finalized — never fabricate supply / price / market cap.
  tokenomics: null,
};

// X is the ONLY social channel. Handle not provided yet -> placeholder.
export const SOCIAL = {
  xUrl: "https://x.com/LumoraBSC",
  xHandle: "@LumoraBSC",
};

// Verify destination URLs before presenting as official.
export const GIGGLE_ACADEMY = {
  // Left null until destination URLs are verified through an official channel.
  officialUrl: null,
};

export const BRAND_ASSETS = {
  logo: "/assets/lumora-logo.jpeg",
  banner: "/assets/lumora-ban.jpeg",
  background: "/assets/lumora-backround.jpeg",
};
